import { Component, computed, input } from '@angular/core';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Card, CardStatus } from '../../../../_interfaces/cards.interface';
import { EmptyIndicatorPipe } from '../../../pipes/empty-indicator.pipe';

@Component({
  selector: 'app-virtual-card-static',
  imports: [NgOptimizedImage, EmptyIndicatorPipe, NgClass],
  templateUrl: './virtual-card-static.component.html',
})
export class VirtualCardStaticComponent {
  cardDetail = input.required<Card>();
  isCentered = input<boolean>();
  isLoading = input<boolean>();

  isDisabled = computed(() => {
    return this.cardDetail().status === CardStatus.Removed || this.cardDetail().status === CardStatus.Blocked;
  });

  cardExpiry = computed(() => {
    if (!this.cardDetail()?.expiry_date) return null;
    const [year, month] = this.cardDetail().expiry_date.split('-');
    const shortYear = year.slice(-2);
    return `${month}/${shortYear}`;
  });
}
